import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetComponentRoundByFlowAndActionGUID = createAsyncThunk(
  "FlowComponent/GetComponentRoundByFlowAndActionGUID",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/FlowComponent/GetComponentRoundByFlowAndActionGUID",
        parameters
      );

      const data = response.data.result; 

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetComponentRoundByFlowAndGUID = createAsyncThunk(
  "FlowComponent/GetComponentRoundByFlowAndGUID",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/FlowComponent/GetComponentRoundByFlowAndGUID",
        parameters
      );

      const data = response.data.result; 

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const FlowComponent = createSlice({
  name: "FlowActionByTaskId",
  initialState: {
    FlowComponent: [],
    loadingFlowComponent: false,
    errorFlowComponent: null,
    //////////////////////////////////////
    FlowComponentByFlowAndGUID: [],
    loadingFlowComponentByFlowAndGUID: false,
    errorFlowComponentByFlowAndGUID: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetComponentRoundByFlowAndActionGUID.pending, (state, action) => {
        state.loadingFlowComponent = true;
        state.FlowComponent = action.payload;
        state.errorFlowComponent = null;
      })
      .addCase(GetComponentRoundByFlowAndActionGUID.fulfilled, (state, action) => {
        state.loadingFlowComponent = false;
        state.FlowComponent = action.payload;
      })
      .addCase(GetComponentRoundByFlowAndActionGUID.rejected, (state, action) => {
        state.loadingFlowComponent = false;
        state.FlowComponent = action.payload;
      });
      //////////////////////////GetComponentRoundByFlowAndGUID////////////////////////////////
      builder
      .addCase(GetComponentRoundByFlowAndGUID.pending, (state, action) => {
        state.loadingFlowComponentByFlowAndGUID = true;
        state.FlowComponentByFlowAndGUID = action.payload;
        state.errorFlowComponentByFlowAndGUID = null;
      })
      .addCase(GetComponentRoundByFlowAndGUID.fulfilled, (state, action) => {
        state.loadingFlowComponentByFlowAndGUID = false;
        state.FlowComponentByFlowAndGUID = action.payload;
      })
      .addCase(GetComponentRoundByFlowAndGUID.rejected, (state, action) => {
        state.loadingFlowComponentByFlowAndGUID = false;
        state.FlowComponentByFlowAndGUID = action.payload;
      });
  },
});

export default FlowComponent.reducer;
